<template>
  <div
    v-if="item.img_desktop"
    class="d-flex justify-center align-center px-3 py-5 py-md-7 py-lg-8 item"
  >
    <a
      v-if="item.link"
      :href="item.link"
      :target="item.target ? '_blank' : '_self'"
    >
      <img
        class="d-block item-img"
        :src="
          files +
          (smAndDown && item.img_mobile ? item.img_mobile : item.img_desktop)
        "
        width="100%"
      />
    </a>
    <img
      v-else
      class="d-block item-img"
      :src="
        files +
        (smAndDown && item.img_mobile ? item.img_mobile : item.img_desktop)
      "
      width="100%"
    />
  </div>
</template>

<script>
const _config = {
  mod: "banners",
};

export default {
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 1170 / 170;
    -o-object-fit: contain;
    object-fit: contain;
  }
}
</style>
